module.exports = __webpack_public_path__ + "img/pdf_format.c1ae6d25.png";